module.exports = __webpack_public_path__ + "media/images/favicons/mstile-150x150-5a2d7979fc370844670b186d3bde402a.png";